
const WalletButton = () => {
    return (
      <button className="wallet__btn">Connect Wallet</button >
    )
  }
  
  export default WalletButton